import React, { ReactNode } from 'react';
import Slider from 'react-slick';
import KeyboardArrowLeftIcon from '@mui/icons-material/KeyboardArrowLeft';
import KeyboardArrowRightIcon from '@mui/icons-material/KeyboardArrowRight';
import { Box } from '@mui/material';

function CustomCarouselContainer({ children }: { children: ReactNode }) {
  // With infinite:false, react-slick mispositions the track (shifted right by a
  // full slide) when there are fewer slides than slidesToShow — clamp to count.
  const count = Math.max(1, React.Children.count(children));
  const fit = (n: number) => Math.min(n, count);
  const settings = {
    className: 'slider variable-width',
    slidesToShow: fit(4),
    slidesToScroll: fit(4),
    infinite: false,
    responsive: [
      {
        breakpoint: 1680,
        settings: {
          slidesToShow: fit(3),
          slidesToScroll: fit(3),
        },
      },
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: fit(2),
          slidesToScroll: fit(2),
        },
      },
      {
        breakpoint: 980,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
    nextArrow:
      // eslint-disable-next-line react/jsx-indent
      <div>
        <KeyboardArrowRightIcon />
      </div>,
    prevArrow:
      // eslint-disable-next-line react/jsx-indent
      <div>
        <KeyboardArrowLeftIcon />
      </div>,
  };
  return (
    <Box sx={{
      mx: {
        xs: -2,
        sm: -1,
        overflow: 'hidden',
      },
    }}
    >
      <Slider {...settings}>{children}</Slider>
    </Box>
  );
}

export default CustomCarouselContainer;
